import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ChartContext } from 'src/app/shared/chart/chart.models';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';
import { getFingerprintDayCounts } from '../../vehicle-fingerprint.utils';

@Component({
  selector: 'app-vehicle-fingerprint-quality',
  templateUrl: './quality.component.html',
  styleUrls: ['./quality.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintQualityComponent implements OnChanges {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };
  dayCounts = getFingerprintDayCounts(this.context);

  chartContext: ChartContext = {
    type: 'ring-gauge',
    title: 'امتیاز کیفیت داده',
    data: [],
    colors: ['#3adab5', '#204059'],
  };

  ngOnChanges(): void {
    this.dayCounts = getFingerprintDayCounts(this.context);
    const confidence = this.confidence;
    this.chartContext = {
      ...this.chartContext,
      data: confidence === null ? [] : [{ name: 'امتیاز کیفیت داده', value: confidence }],
    };
  }

  get confidence(): number | null {
    const value = this.context.summary?.fFingerprintConfidence;
    return typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= 100 ? value : null;
  }

  get baselineElectricalDays(): number | null {
    const value = this.context.summary?.iElectricalValidDays;
    return Number.isInteger(value) && value >= 0 ? value : null;
  }
}
